<template>
	<div id="app">
		<router-view/>
	</div>
</template>

<script>
	export default {
		name: 'app',
		components: {
		}
	}
</script>

<style>
body{ background: #f6f6f6; font-size: 14px;}
*{box-sizing: border-box;margin: 0;padding: 0;}

.ui-flex{display: -webkit-box;display: -webkit-flex;display: flex;}
.ui-flex-wrap{-webkit-flex-wrap:wrap;flex-wrap:wrap;}	
.ui-flex-1{-webkit-box-flex:1;-webkit-flex: 1;flex: 1;}
.col-6{width:16.66%;}
.col-5{width:20%;}
.col-4{width:25%;}
.col-3{width:33.3333%;}
.col-2{width:50%;}
.col-1{width:100%;}

/*颜色*/
a{ color: #333;}
.c_666{ color: #666;}
.c_999{ color: #999;}
.c_aaa{ color: #aaa;}
.c_ccc{ color: #ccc;}
.c_warning{ color: #ff6801;}
.c_success{ color: #1cd26d;}
.c_red{ color: #e12e2e;}
.c_primary{color:#df4242;}

.info{background: #fff; padding: 16px; margin-bottom: 10px;}
.info-name{ font-size: 18px; font-weight: bold; margin-bottom: 16px;}
.info-item{display: -webkit-box;display: -webkit-flex;display: flex; padding: 4px 0;}
.info-item-lab{ color: #999; width: 100px; }
.info-item-val{-webkit-box-flex:1;-webkit-flex: 1;flex: 1;}
.info-item-hr{ border-bottom: 1px solid #e8e8e8; margin:10px 0;  }
.info-item-val.tr{ text-align: right;}

.page_loading{ text-align: center; padding-top: 100px;}

.nav_bar{ position: fixed; width: 100%; left: 0; top: 0; z-index: 666;}
.cell-access-icon::before{content: " ";display: inline-block;height: 8px;width: 8px;
    border-width: 1px 1px 0 0;
    border-color: #aaa;
    border-style: solid;
    -webkit-transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
    transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
    top: -1px;
    position: absolute;
    top: 50%;
    margin-top: -5px;
    right: 0;
}
.gd-icon::after{content: " ";display: inline-block;height: 6px;width: 6px;
    border-width: 2px 2px 0 0;
    border-color: #B2B2B2;
    border-style: solid;
    -webkit-transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
    transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
    top: -2px;
    position: absolute;
    top: 50%;
    margin-top: -4px;
		right: 0;
}
	
/*0.5px*/
.retina-1px-border-top:before,.retina-1px-border-bottom:after,.cell:before,.cell:after,.cell-item:after {
	position: absolute;
	content: "";
	height: 1px;
	background: rgba(32,35,37,0.15);
	left: 0;
	right: 0
}

.retina-1px-border-top:before,.cell:before{
	top: 0
}

.retina-1px-border-bottom:after,.cell:after,.cell-item:after {
	bottom: 0
}

.retina-1px-border-left:before,.retina-1px-border-right:after {
	position: absolute;
	content: "";
	width: 1px;
	background: rgba(32,35,37,.15);
	top: 0;
	bottom: 0
}

.retina-1px-border-left:before {
	left: 0
}

.retina-1px-border-right:after {
	right: 0
}

.retina-1px-border:after {
	position: absolute;
	content: "";
	top: 0;
	left: 0;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	border: 1px solid rgba(32,35,37,.15)
}

@media (-webkit-min-device-pixel-ratio:1.5),(min-device-pixel-ratio:1.5),(min-resolution:144dpi),(min-resolution:1.5dppx) {
	.retina-1px-border-top:before,.retina-1px-border-bottom:after,.cell:before,.cell:after,.cell-item:after {
		-webkit-transform: scaleY(0.5);
		transform: scaleY(0.5)
	}

	.retina-1px-border-left:before,.retina-1px-border-right:after {
		-webkit-transform: scaleX(0.5);
		transform: scaleX(0.5)
	}

	.retina-1px-border:after {
		width: 200%;
		height: 200%;
		-webkit-transform: scale(0.5);
		transform: scale(0.5)
	}

	.retina-1px-border-top:before,.retina-1px-border-left:before,.retina-1px-border:after {
		-webkit-transform-origin: 0 0;
		transform-origin: 0 0
	}

	.retina-1px-border-bottom:after,.retina-1px-border-right:after {
		-webkit-transform-origin: 100% 100%;
		transform-origin: 100% 100%
	}
}

@media (-webkit-device-pixel-ratio:1.5) {
	.retina-1px-border-top:before,.retina-1px-border-bottom:after,.cell:before,.cell:after,.cell-item:after {
		-webkit-transform: scaleY(0.6666);
		transform: scaleY(0.6666)
	}

	.retina-1px-border-left:before,.retina-1px-border-right:after {
		-webkit-transform: scaleX(0.6666);
		transform: scaleX(0.6666)
	}

	.retina-1px-border:after {
		width: 150%;
		height: 150%;
		-webkit-transform: scale(0.6666);
		transform: scale(0.6666)
	}
}

@media (-webkit-device-pixel-ratio:3) {
	.retina-1px-border-top:before,.retina-1px-border-bottom:after,.cell:before,.cell:after,.cell-item:after {
		-webkit-transform: scaleY(0.3333);
		transform: scaleY(0.3333)
	}

	.retina-1px-border-left:before,.retina-1px-border-right:after {
		-webkit-transform: scaleX(0.3333);
		transform: scaleX(0.3333)
	}

	.retina-1px-border:after {
		width: 300%;
		height: 300%;
		-webkit-transform: scale(0.3333);
		transform: scale(0.3333)
	}
}

@media (-webkit-device-pixel-ratio:2.625) {
	.retina-1px-border-top:before,.retina-1px-border-bottom:after,.cell:before,.cell:after,.cell-item:after {
		-webkit-transform: scaleY(0.38095);
		transform: scaleY(0.38095)
	}

	.retina-1px-border-left:before,.retina-1px-border-right:after {
		-webkit-transform: scaleX(0.38095);
		transform: scaleX(0.38095)
	}

	.retina-1px-border:after {
		width: 300%;
		height: 300%;
		-webkit-transform: scale(0.38095);
		transform: scale(0.38095);
		
	}
}


</style>
